const faqsByTopic = {
'getting-started': [
    {
      category: 'About Us',
      items: [
        {
          question: 'What is Nifty10?',
          answer:
            `Nifty10 is a fantasy stocks prediction game! Users can predict the performance of various stocks within a given timeframe, and those with the most accurate predictions can win real cash prizes. It’s a fun way to test your knowledge of the market trend and see how well you can predict stock movements.
            Just remember to always invest responsibly and do your research before making any financial decisions!
            Let’s download the app and get you started.`
        },
        {
          question: 'How to download the Nifty10 app?',
          answer:
            `👉 Head to www.Nifty10.com on your desktop or mobile browser and enter your ‘mobile number’ to get the download link.
            👉 As an Android user, you can also download the Nifty10 app from the Google Play Store.`
        }
      ]
    },
    {
      category: 'Login & Registration',
      items: [
        {
          question: 'How do I register?',
          answer: `1. Download the Nifty10 app on your phone.
          2. Register with your mobile number & OTP. And that’s it!
          3. Select your Bid & play.
          4. Please make sure to add your Email ID for the latest updates.
          5. In case you still need help, you may Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I register using a Referral Code?',
          answer: '1. Click on the link you received with the code and download the Nifty10 app.\n2. Once you open the app, enter the mobile number you want to register with.\n3. Next, click on “Referral Code” and enter your Referral Code.\n4. Enter the OTP sent to the mobile number and you’re successfully registered!\nWelcome to Nifty10. Let the games begin!\nHere’s all you need to know about the Invite Friends Program!\nIn case you still need help, you may Feel free to reach out to us at info@nifty10.com.'
        },
        {
          question: 'How to login via email id?',
          answer: `Present, We don't have any option to login via email id. we are allowing users to login via mobile number only.
In case you still need help, you may Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'Why can’t I use Facebook or Google login options on iOS?',
          answer: `Due to Apple’s policies, we have disabled the Facebook and Google login options from v3.67.0 onwards for our iOS app. But your experience remains unchanged!
Here’s how you can log in next time:
Use your verified mobile number and log in via OTP .
In case you still need help, you may Feel free to reach out to us at info@nifty10.com`
        }
      ]
    }
  ],
  'how-to-play': [
    {
      category: 'How to Play Nifty10',
      items: [
        {
          question: 'How to play Nifty 10?',
          answer: `Step 1: Login with Mobile number to register on Nifty10 App
Step2: Select the market trend Bullish or Bearish
Step3: Pick up your choice of FIVE stocks and proceed to place the Bid
Step4: Select your choice of bid and pay entry fee and join the slots
Step5: Check the leaderboard for the winners `
        },
        {
          question: 'How do I edit my slots?',
          answer: `Follow these simple steps to edit your slots:
Head to Joined slots’ and select the slot under ‘joined Slots’
Click on ‘Edit icon’ to the right-hand side
Tap the pencil icon on the team you wish to edit
Make the edits, save the changes, and that’s it.`
        },
        {
          question: 'Can I delete a slot?',
          answer: `No, While deleting a slot is not an option, you can:
1. Edit the stocks in joined slot you created or
2. Create a new slot `
        },
        {
          question: 'What are Flexible bids?',
          answer: `Flexible slots are paid slots that don’t get cancelled even if only two teams join. Yes, that’s correct.
Some bids can be flexible bids
The slot takes place even if just two teams join (which means no cancellation even if all slots don’t fill up)
The Prize Pool for the slot keeps increasing as more and more bids join `
        },
        {
          question: 'How many slots can I join in each bid?',
          answer: `We’d want you to have all the opportunities to apply your skill and win big!
So, for you can join up to 15 slots for each Bid. `
        },
        {
          question: 'Can I join a bid with multiple slots?',
          answer: `Absolutely! You can join up to 15 slots in each bid . Click on a bullish/bearish and look out for slots that read ‘Up to 15’. `
        },
        {
          question: 'Can I edit stocks after Market starts?',
          answer: `Stocks edits in already joined slots are not allowed after Markets starts. You can edit your stocks as many times as you want, before 9:00 A.M. `
        }
      ]
    }
  ],
  'my-balance': [
    {
      category: 'Withdrawls',
      items: [
        {
          question: 'Is there a daily withdrawal limit?',
          answer: `Yes, there is. You can place up to 3 withdrawal requests a day, not exceeding a total value of Rs. 25000. Each withdrawal request can be for a minimum of Rs. 50 and a maximum of Rs. 10000.

In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'Can I use someone else’s bank details on my Nifty10 account?',
          answer: `It is not recommonded to use someone's bank details. You can verify ONLY your own bank account. If you have one, verify it now.
PS: If you don’t have a bank account, your winnings will keep accumulating in your Nifty10 account and you can use them to join contests.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I withdraw my Discount Bonus?',
          answer: `You can use the Discount Bonus to join more contests and increase your winnings, but you can’t withdraw it.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.  `
        },
        {
          question: 'Why is the amount credited in my bank account different from my withdrawal amount?',
          answer: `According to the new Govt. Tax (TDS) law, effective 1st April 2023, TDS is deducted at 30% of your net winnings, at the time of withdrawal.
E.g, if you place a withdrawal of Rs. 100, an amount of Rs. 30 (i.e. 30% of Rs. 100) will be deducted as TDS and Rs. 70 will be credited to your verified bank account.
Please note: TDS is applicable only on the taxable amount.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. 
Government Notification Bill.pdf`
        },
        {
          question: 'Do I have to pay taxes when I withdraw my winnings on Nifty10?',
          answer: `Yes. As per the new Govt. Tax (TDS) law, effective 1st April 2023, TDS will be deducted at 30% of your taxable amount at the time of withdrawal.
Taxable amount is defined as the difference between your withdrawals and deposits. 
Here’s how it’s calculated:
Note: A, B and D are calculated for this FY i.e. from 1 April 2023 onwards.
In case you need any further help, you can Feel free to reach out to us at info@nifty10.com.  `
        },
        {
          question: 'My withdrawal request is cancelled, what should I do now?',
          answer: `A withdrawal request is usually cancelled if:
1. There’s an issue with your verified bank account
2. Due to a GamePlay Violation
Note: A cancellation reason will also be mentioned against the cancelled transaction.
If the cancellation reasons are incorrect IFSC, name mismatch or incorrect account number.
Please verify your bank account with the correct details and place a fresh withdrawal request. Just ensure your bank IFSC code is part of the updated IFSC list.If the cancellation reason is ‘GamePlay Violation Detected’, we request you to follow the GamePlay rules to avoid such cancellation in future.
In case you still need help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How can I check the status of my withdrawal?',
          answer: `1. Head to the profile picture on the top left-hand side of the app, Click ‘My Balance’.
2. Go to the ‘My Transactions’ panel and check under the ‘Withdrawals’ tab
3. Each withdrawal request you place generates a unique withdrawal ID prefixed by ‘UW’.
4. And, you can check the status of all these withdrawal transactions for the last 6 months.
5. Details beyond the last 6 months can be downloaded via the ‘Download’ icon on the page.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'I’ve placed a withdrawal request, when will I get my money?',
          answer: `A successfully processed withdrawal request via IMPS should get credited almost instantly or within 3 working days. NEFT should get credited within 3 working days, under ‘IDBI BANK’.
PS: If your withdrawal request is processed but not credited to your verified bank account within the above timeframe, please share a PDF copy of your bank statement from the date of withdrawal with us. We’ll check this for you.
write to us at info@nifty10.com .`
        },
        {
          question: 'How do I withdraw my winnings?',
          answer: `It is not recommonded to use someone's bank details. You can verify ONLY your own bank account. If you have one, verify it now.
PS: If you don’t have a bank account, your winnings will keep accumulating in your Nifty10 account and you can use them to join contests.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'Can I use someone else’s bank details on my Nifty10 account?',
          answer: `Tap the profile picture > My Balance > Withdraw > Enter the amount you wish to withdraw.
To place a withdrawal request, make sure:
Your PAN and bank details are verified
Your winning balance is Rs. 50 or more.
Here are a few important things to keep in mind when you place a withdrawal request:
You can place up to 3 withdrawal requests a day
You will see the break up of the TDS (if applicable) and the amount post taxes which will be credited to your bank account
Each request can be of a minimum of Rs. 50 and a maximum of Rs. 1 Crore
Accordingly, a maximum withdrawal of Rs. 3 crores can be placed each day, across 3 transactions
Your withdrawal can take up to 3 working days to get credited to the verified bank account.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        }
      ]
    },
    {
      category: 'Deposits',
      items: [
        {
          question: 'My amount was not added to my Nifty10 account, will it be auto-refunded?',
          answer: `In case your deposit transaction fails, the amount will be auto-credited to your source account as per the timelines below.  If the refund is not credited to your source account within this time frame, please contact your bank for more details.
  Auto refund time frame:
Wallets : Within 2 Hours     
Net Banking : Within 2-3 Working Days     
UPI : Within 24 Hours     
Debit/ Credit Cards : Within 2-3 Working Days    
PS: Working days exclude weekends and bank holidays.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How can I get a refund of my deposit?',
          answer: `Maintaining an unutilized deposit balance in your Nifty10 account makes it easy to join contests.
However, if you’d like to have any unutilized deposit refunded, write to us  here.
Your deposit may be refunded if it is not linked to any offers or promo balance such as discount bonus on NiftyCoins.
Also, deposit refunds are subject to the deduction of applicable GST. Any taxes deducted at the time of deposit are non-refundable and only the balance amount without GST will be refunded.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I manage PhonePe / Paytm wallets on Nifty10?',
          answer: `To link wallets, Head to the Side Navigation Menu > My Balance > Add > Wallets and tap on ‘Link Account’ to link your Paytm/ PhonePe wallets. Follow the onscreen instructions, authenticate using OTP and done.
PS: Your Paytm/ PhonePe wallet should be linked to the same mobile number you’ve used on Nifty10.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'Can I link more than one Paytm account on Nifty10?',
          answer: `No, You can link only one Paytm account on Nifty10.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I add cash to my Nifty10 account?',
          answer: `You can add cash through either of the following two options on your Nifty10 app:
Profile Picture on the top left-hand side corner or Wallet icon on the top right hand side corner.
Next,
1. Click on Add Cash
2. Enter the ‘Amount to add’
3. Select your preferred payment method from UPI, credit or debit cards (excluding American Express or cards issued outside of India), wallets and net
banking.
4. Follow the on-screen instructions to complete your payment and done!
The deposit money can be checked in the “My Recent Transactions” section.
PS:
If the cash hasn’t been added to your account within 24 hours, the amount will be auto-refunded to the source account
Effective 1 October 2023, GST will be calculated at the rate of 28% on amount deposited in your Nifty10 account
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I manage my cards on Nifty10?',
          answer: `To add a card: My Balance > Add Cash > Enter the amount you wish to add > Add New Card > Enter Card Details > Pay
To remove a card: My Balance > Manage Payments > Select and remove the card you wish to remove > Delete Card
PS: There is no limit to the number of cards you can save in your Nifty10 account.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I add cash via UPI?',
          answer: `Side Navigation Menu > My Balance > Add Cash > Amount to add > Add
1. Tap UPI and select your preferred payment gateway (GPay, PhonePe, Paytm, etc.)
2. Follow the on-screen instructions to complete your payment OR
3. Alternatively, you can enter your UPI ID directly in the box below the UPI options. This will redirect you to your bank’s website to complete the transaction.
PS: Direct transactions made to any VPA will not get added to your Nifty10 app.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        }
      ]
    },
    {
      category: 'TDS on Winnings',
      items: [
        {
          question: 'Is there any TDS if I don’t withdraw money in the entire financial year?',
          answer: `The taxable amount at the end of the financial year (31 March) will be subject to Govt. Tax (TDS) at 30%. TDS will be deducted from your closing balance.
Note: A, B, D & E are calculated for the current FY i.e. 1 April 2023 onwards.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'What if I pay extra TDS?',
          answer: `Don’t worry; you can claim your TDS refund when filing your Income Tax Returns (ITR) for that financial year.
Remember to download your quarterly TDS certificates from the Nifty10 app once they are published by following these steps:
1. Go to the profile icon.
2. Select “My balance.”
3. Click on “My Transactions.”
4. Click on the download icon located at the top right corner of the screen.
5. Select the TDS certificate option.
6. Click on “Send to Email.”
If you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How can I check all transactions and TDS-related details?',
          answer: `Go to My Balance ➡️ My Transactions ➡️ Others
Click on the transaction for which you want to see the details.
You can check out the detailed TDS breakup for each withdrawal.
You can also download the quarterly TDS certificate here once it is published.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'When will I get my TDS certificate?',
          answer: `Once you have verified your PAN on your Nifty10 account, you can email the TDS certificate to your verified email ID via your Nifty10 app.
For this, go to:
Profile pic>> My Balance>> My Transactions>> Download icon (top right-hand side corner)>> TDS certificate.
If TDS has been deducted in a quarter, the respective TDS certificate link will be enabled. Simply check the box next to the TDS certificate and then click ‘Send to email’.
For the current FY, the TDS certificate will be available as per the following schedule:
Winning month Timeframe to receive TDS
Apr’23 to Jun’23 after 31st Jan’24
Jul’23 to Sep’23 after 31st Jan’24
Oct’23 to Dec’23 after 23rd Feb’24
Jan’24 to Mar’24 after 31st Jul’24
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How is TDS calculated?',
          answer: `As per the new Govt. Tax (TDS) law effective 1 April 2023, TDS will be deducted at 30% of your taxable amount (i.e. net winnings) at the time of withdrawal.
Taxable amount is defined as the difference between your withdrawals and deposits in the FY. Here's how it is calculated.
Note: A, B & D are calculated for the current FY i.e. from 1 April 2023.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I download my TDS statement?',
          answer: `To obtain your TDS statements, please follow these steps:
Go to the profile icon.
Select "My balance."
Click on "My Transactions."
Click on the download icon located at the top right corner of the screen.
Go to the "TDS statement".
Select the Financial year.
Click on "Send to Email."
Please note: The TDS statement might take a few minutes to be forwarded to your Email ID.
If you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'What is TDS deduction on 31 Mar, 2024?',
          answer: `As per amendments to the Income Tax Act that came into effect on 1 April, 2023, Govt Taxes (TDS) are applicable on your Net Winnings.
Hence, TDS applicable on your Net Winnings for the Financial Year 2023-24 (1 April 2023 to 31 March 2024) will be automatically deducted from your Nifty10 account on 31 March 2024, 11:59 PM.
How will it be calculated?
Your Taxable Amount (Net Winnings) = A – B – C – E + D
Where
A = Total withdrawals in the FY
B = Total deposits in the FY
C = Opening balance (Unused Deposits + Winnings) at the beginning of FY
E = Amount on which TDS has been deducted in the FY
D = Closing Balance (Current Balance on 31 March, 2024, including Unused Deposits and Winnings)
For more details, click here.
For any doubts, feel free to write to us .`
        },
        {
          question: 'Is TDS applied if I have net losses?',
          answer: `No TDS will be applicable in case of net losses at the time of withdrawal or at the end of the financial year.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'Is there any threshold amount above which the TDS will be deducted?',
          answer: `No, TDS at 30% will be deducted on net winnings on every withdrawal amount or on net winnings at the end of every financial year, effective 1st April 2023.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'Will my account balance, held till 31 March 2023, also get affected?',
          answer: `No. Don’t worry; your account balance holdings before 1 April 2023 will not incur a TDS deduction as per the new update.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'What is the difference between the calculation of taxable amount before and after 1 May 2023?',
          answer: `Tax deduction has been updated to make it easier for you.
Here’s how net winnings were calculated earlier, i.e. from 1 April 2023 to 30 April 2023.
Taxable Amount (Net Winnings) = Total winnings – (Total Entry – Discount Bonus/ Discount)
Effective 1 May 2023, the taxable amount is calculated as follows:
Here’s an example to help you understand the changes.
Let’s see how this would affect your withdrawals as compared to the old scheme (1 April – 30 April) if you were to withdraw this Rs. 20000 in 3 parts, where Rs. 7000 is the taxable amount.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        }
      ]
    },
    {
      category: 'GST (Govt. Tax) on Deposits',
      items: [
        {
          question: 'How can I check the GST deducted so far?',
          answer: `The Government of India has implemented a change in its taxation laws, where GST will now be charged at the rate of 28% on the amount a user deposits.
This change took effect from 1 October 2023.
To view your GST deductions since then,
Navigate to your profile picture at the top left.
Click on ‘My Balance’ and proceed to ‘My Transactions’.
Download the transaction history by clicking the download icon at the top right
The transaction history will be emailed to the email ID updated on your Nifty10 account
This will give you the deposit-wise GST deductions and the resulting account balance. Additionally, get insights into the Discount Points awarded for each deposit since October 1 2023.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How is the entry amount deducted after the GST changes?',
          answer: `30% of any Contest Entry will be deducted from your Discount Points balance after all other available discounts are applied.
Remember: Discount Points are valid for 90 days from the date of credit and cannot be withdrawn.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How is GST calculated and applied?',
          answer: `Effective October 1, 2023, Nifty10 has changed how deposits work to comply with the new 28% Government Tax (GST).
GST will now be applicable on deposits.
But don’t worry; you can still join contests with the entire amount you add.
For example, if you add Rs. 100, you will be able to play for the full Rs. 100.
What changes when you add cash?
Calculate your next deposit:
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        }
      ]
    },
    {
      category: 'Winnings',
      items: [
        {
          question: 'Is tax deducted on winnings?',
          answer: `No! Your winnings will be credited as-is.
As per the new Govt. Tax (TDS) law, effective 1st April 2023, TDS will be deducted at 30% of your taxable amount at the time of withdrawal.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'If other players are on the same rank as me, how much will I win?',
          answer: `The winnings will be equally split between all the players who are tied at that rank.
For example
The winning amount for Rank 1 is Rs.1,000 and for Rank 2 is Rs.500
Now, if two players have a tie at the 1st rank, the total winnings for both the 1st and 2nd ranks will be split equally between both the winners
In this case, both the players will win Rs.750 each i.e. (Rs.1000 + Rs.500)/2 = Rs.750
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How soon will I receive my winnings?',
          answer: `Usually within 4 hours after the match is completed and winners are declared!
For matches ending late at night, your winnings will be added to your Nifty10 account the next morning after the match winners are declared.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        }
      ]
    },
    {
      category: 'Understanding Your Transactions​',
      items: [
        {
          question: 'How do I check my Nifty10 account balance?',
          answer: `Visit the Side Navigation Menu >  My Balance. Alternatively, you can click the icon in the top-right corner of the app.
You’ll see your account balance in 3 categories:
Deposit – Cash you added to your Nifty10 account which hasn’t been used yet to join any cash contests
Winnings – Amount you earned by joining and winning cash contests
PS: You also receive a confirmation email with details for each successful transaction on your registered email ID.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'Where do I check my transaction history on Nifty10?',
          answer: `Visit the Side Navigation Menu >  My Balance > My Transactions. Simply click on the download icon in the top right corner of the app and you can download the following:
You can download your Transaction statement (up to 1 year)
TDS Statement (Financial year)
TDS Certificate (Only available if taxes are applicable)
If you face any issues, please write to us  and we’ll assist you.`
        },
        {
          question: 'Can I transfer balance from one Nifty10 account to another?',
          answer: `No! Your balance cannot be transferred to any other Nifty10 account.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How is my account balance utilised while joining paid contests?',
          answer: `Your entry amount will be covered in the following order:
For public cash contests:
Discount Bonus (As per Discount bonus applicability)
Deposit (Including Discount Points)
Winnings
For private cash contests:
Deposit (Including Discount Points)
Winnings
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        }
      ]
    }
  ],
  'profile-verification': [
    {
      category: 'Verify My Account',
      items: [
        {
          question: 'Do I have to verify my Aadhaar on the PlayStore app version?',
          answer:
            `You can verify your Aadhaar card, Voter ID, or Driving License as per the Google PlayStore policy, to ensure compliance with State Gaming laws.
Depending on the document you choose, please follow the simple steps below to successfully verify your account and start playing on Nifty10.
1. To verify your Aadhaar, you have the following options:
2. If your Aadhaar has a mobile number linked to it, use the ‘Verify Aadhaar via OTP.’
3. If your Aadhaar does not have a mobile number linked to it, verify using either the option of ‘Enter Aadhaar number’ or ‘Upload Aadhaar’
4. To verify your Driving License or Voter ID, upload a soft copy of the document using the ‘Upload’ option
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I verify my email address?',
          answer:
            `Head to My Balance, tap on Verify To Withdraw > Email Address and follow the on-screen instructions.
PS: We’ll send an OTP to your email ID, and you’ll have to enter the OTP to complete the verification.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I verify my email address?',
          answer:
            `Head to My Balance, tap on Verify To Withdraw > Email Address and follow the on-screen instructions.
PS: We’ll send an OTP to your email ID, and you’ll have to enter the OTP to complete the verification.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I verify my mobile number?',
          answer:
            `If you’re logged in, head to My Balance > Verify To Withdraw > Enter your mobile number. Enter the OTP and you’re all done.
PS: Please ensure that the mobile number you wish to verify is not registered on any other Nifty10 account.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.  `
        },
        {
          question: 'Is PAN and bank verification mandatory?',
          answer:
            `Yes! Users need to verify their PAN and bank details for the following reasons –
Withdrawals involve transferring your winning amount to your bank account to issue TDS certificates on time whenever applicable
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'How do I verify my Nifty10 account?',
          answer:
            `To verify your account, simply head to ‘My Balance’ > ‘Verify To Withdraw’ and then:
Verify your Email ID
Verify Your Mobile Number
Verify your PAN card
Verify your bank account
PS: You can withdraw your winnings only after successful verification of your Dream11 account.
If you have downloaded your app from the Google PlayStore, you also need to verify one of the following documents so you can ‘Add Cash’ and join paid contests.
You can verify the following:
1. Aadhaar
2. Driving License
3. Voter ID
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        }
      ]
    },
    {
      category: 'Issue with PAN Verification',
      items: [
        {
          question: 'How do I verify my PAN card?',
          answer: `Withdrawals on Nifty10 involve a transfer of money; hence, verifying your PAN card and bank account is mandatory.
Please note:
Full name on PAN card must match:
Full name on previously verified KYC document,Full name on bank account to be verified,It takes max. 1 day to get PAN verified
To verify your PAN Card:
Head to My Balance by tapping on your profile pic > Winnings > Verify To Withdraw and tap on ‘Verify’ next to PAN Card
Enter your name, PAN card number, date of birth and state exactly as mentioned on your PAN Card
Upload a clear image of your PAN card and tap on ‘Submit Details’
You’re done! Your verification request is submitted, and the verification will be completed in a maximum of 1 working day.
PS: Once verified, a PAN card can’t be used on any other Nifty10 account. It also can’t be unlinked from your Nifty10 account.
In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        },
        {
          question: 'Why is my PAN verification getting rejected?',
          answer: `If your PAN verification is rejected, please recheck the following:
The PAN card should not be verified on any other Nifty10 account  
The name on the PAN must match any previous KYC document verified on your account  
The PAN image uploaded should be clear and of the entire PAN Card  
The Date of Birth updated on the form should match the Date of Birth on the PAN  
The correct PAN number & details should be updated in all relevant fields  
The PAN copy uploaded should NOT be password-protected  
The PAN card uploaded should only be an individual’s and not a company PAN card  
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'Can I change the verified PAN card?',
          answer: `Once verified, you can’t change your PAN card or use it on any other Nifty10 account.

In case you need any further help, Feel free to reach out to us at info@nifty10.com. `
        }
      ]
    },
    {
      category: 'Issue with Bank Verification',
      items: [
        {
          question: 'How do I verify my bank account?',
          answer: `You need a verified bank account on Nifty10 to be able to withdraw your winnings. You can verify your bank account only after verifying your PAN card.
To verify your bank account:
Head to My Balance > KYC Details and tap on Bank Account
Enter the bank account number that’s linked to your PAN card along with the IFSC code, Bank name and, Branch name, add your state and upload a clear image of your bank document.
Your bank account verification will be completed in a maximum of 1 working day.
A few important points to keep in mind: 
Accepted documents – bank passbook, cheque or bank statement which has your name, bank account number, IFSC and branch details
Your bank IFSC is part of the attached IFSC list
Password-protected files will be rejected
An email confirmation will be sent once your bank details are verified.
A PAN or bank account verified on a Nifty10 account cannot be verified on any other Nifty10 account
You can also verify payment bank accounts. However, wallets cannot be verified
Users aren’t permitted to verify NRE bank accounts
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'Why is my bank verification getting rejected?',
          answer: `To verify your bank details, you’ll have to first verify your PAN card.
Post that, you can link a bank account or payment bank account on your Nifty10 account.
For this, upload any official bank proof document like a cancelled cheque, passbook, account statement, etc., that has all the necessary details which are the account holder’s name, IFSC code, and bank account number.
If your bank verification is rejected, do re-check the following critical points before you re-attempt the  verification:
Name on the bank proof uploaded matches the name on the PAN card
Correct bank account number, IFSC code and name are updated in the form on the app
Bank proof uploaded is a valid proof like a cancelled cheque, account statement, or passbook
Bank details like account number, IFSC code and name are clearly visible on the bank proof that you upload
Details on the form and on the bank proof copy match each other
Uploaded bank proof is not password protected
Entire bank account number is visible on the bank proof uploaded
No payment wallets are submitted. Payment banks are accepted.
IFSC code belongs to the list of acceptable IFSC codes attached in this article
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I change my bank account?',
          answer: `First, you’ll need to unlink your bank account and place a verification request for a new one.
You can change your bank account up to 10 times directly via the app.
Here’s how to unlink your bank account.
Go to Profile
Go to My Balance
Click on KYC details
Go to Bank Account (Verified)
Scroll down and click on Unlink
Now, link your new bank account from the same KYC tab. For this:
Tap Bank Account and type your bank account details
Upload a bank proof, and that’s it!
Here are some important points to keep in mind while changing your bank account:
Once verified, the same bank account can’t be verified on any other Nifty10 account
You can verify a bank account in your name only where the bank account name matches the name on the verified PAN
NRE accounts and Wallets can’t be verified, while payment banks do work if you are an Android user.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I check if my bank account is verified?',
          answer: `If your bank account is verified, you’ll see the option to ‘Withdraw Instantly’ in the ‘My Balance’ section. If it is not verified, you’ll see the option of ‘Verify to Withdraw’.
To check which bank account you’ve verified, head to My Balance > KYC Details, and you’ll see the bank name and account number.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        }
      ]
    },
    {
      category: 'Issue with Aadhar',
      items: [
        {
          question: 'I do not have an Aadhaar. How can I complete my verification?',
          answer: `Don’t worry!
If you do not have an Aadhaar, you can also verify your Voter ID or Driving License.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        }
      ]
    },
    {
      category: 'Managing my Profile',
      items: [
        {
          question: 'How do I unsubscribe from notifications?',
          answer: `You can unsubscribe from email notifications from the email and mobile notifications from the app.
To unsubscribe from email notifications:
Click on ‘Email Preferences’ at the bottom right-hand corner of the email, select a reason for unsubscribing, and click “Unsubscribe”. That’s it.
To unsubscribe from mobile notifications:
Head to ‘My Info & Settings’ and select your preferences to allow/ block mobile notifications from ‘Allow SMS Notifications’. That’s all, folks!
PS: To resubscribe to email notifications, Feel free to reach out to us at info@nifty10.com; we’re alwa ys here to help.`
        },
        {
          question: 'Why am I not receiving emails from Nifty10?',
          answer: `To get emails from Nifty10, please ensure:
Your email address is correctly updated in the  “My Profile” section
You’re subscribed to receive emails from Nifty10
You’ve added info@nifty10.com to your safe sender list
You’ve checked your Spam folder and marked emails from Nifty10 as “Not Spam”
If you’re still not receiving emails from us, please write to us  and we’ll check this for you.`
        },
        {
          question: 'How do I contact Nifty10?',
          answer: `Right here! You can find (almost) all the answers you’re looking for on Nifty10 Help. If you don’t find them here, Feel free to reach out to us at info@nifty10.com  anytime. We’re always here for you.`
        },
        {
          question: 'I see an error ‘Cannot Change Mobile’ when I try to change my mobile number. What should I do now?',
          answer: `In such a case, please follow one of the steps below:
If you’ve verified your PAN card on Nifty10, Please write to us at info@nifty10.com with a copy of your PAN card, and we’ll help you out.
If you haven’t verified your PAN card yet, Please verify your PAN card on the app and write to us at info@nifty10.com with a copy of your PAN card, and we’ll take it from there.
If you wish to continue without changing your mobile number, tap on ‘Close’ on the screen you see to get back to your favourite fantasy sports!
To write to us, click here.`
        },
        {
          question: 'How do I change my state?',
          answer: `Go to ‘My Info & Settings’ from the side navigation menu.
However, in case you have verified your KYC documents (i.e. Aadhaar/ Driving Licence/ Voter ID) on your Nifty10 account, the State will be auto-picked based on this document and cannot be changed via the app.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'What information can I hide from my profile?',
          answer: `To change your profile settings, go to My Info And Settings > Privacy Settings and switch the toggle off for all the information you want to hide.
PS: In case you hide team details from your profile, you will not be able to see others’ team details as well.
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I change my email ID?',
          answer: `Go to ‘My Info & Settings’ > Change (tab next to the email ID), enter the new email ID and the OTP you receive on the new email ID, and that’s it!
Your new email ID is verified, and we’ll notify you about the change via email.
Here are a few things to remember while changing the mobile number from the app:
You’re on the latest app version
Your new email ID is not linked to any other Nifty10 account
You can change your email ID a maximum up to 3 times via the app
In case you need any further help, Feel free to reach out to us at info@nifty10.com.`
        },
        {
          question: 'How do I change my mobile number?',
          answer: `Go to ‘My Info & Settings’ by tapping on your profile pic > Change (tab next to the mobile number), enter the new mobile number, enter the new OTP you receive, and that’s it!
Your new number is verified, and we’ll send you a confirmation on your verified email ID.
A few things to remember while changing the mobile number from the app:
Your new mobile number is not linked to any other Nifty10 account
You can change your mobile number thrice from the app
In case you need further help in changing your mobile number, please Feel free to reach out to us at info@nifty10.com .`
        }
      ]
    }
  ],
'network-on-nifty10': [
  {
    category: 'Building Your Network',
    items: [
      {
        question: 'What is the Nifty10 network?',
        answer: `It’s a community of stock market and fantasy game enthusiasts playing skill-based prediction contests.
You can join public bids, compete with others, and climb the leaderboard.`
      },
      {
        question: 'How can I invite my friends to Nifty10?',
        answer: `Use your referral code or invite link to bring friends onboard.
They’ll join using your code, and you’ll both earn rewards once they play their first bid.`
      }
    ]
  },
  {
    category: 'Playing with Friends',
    items: [
      {
        question: 'Can I play bids with my friends?',
        answer: `Yes! You and your friends can join the same public bids and compete together.
Private bids are not yet available, but we’re working on it!`
      },
      {
        question: 'Can I see what bids my friends joined?',
        answer: `Currently, Nifty10 does not show other users’ joined bids for privacy reasons.
However, you can challenge each other to join the same slot.`
      }
    ]
  },
  {
    category: 'Leaderboard & Community',
    items: [
      {
        question: 'What is the leaderboard?',
        answer: `The leaderboard ranks users based on how accurate their predictions are in bids.
The higher your accuracy, the higher your rank—and the more you can win!`
      },
      {
        question: 'Can I follow other users?',
        answer: `Currently, you can’t follow users directly, but this feature may be introduced in the future.
Stay tuned for more social features!`
      }
    ]
  }
],
'offers-and-rewards': [
  {
    category: 'Referral Program',
    items: [
      {
        question: 'How do I refer a friend to Nifty10?',
        answer: `1. Open the Nifty10 app and go to the ‘Invite Friends’ section.
2. Share your referral link or code with your friends.
3. When they sign up and play their first bid, both of you get a reward!
It’s a win-win!`
      },
      {
        question: 'What rewards do I get for referring someone?',
        answer: `You can earn a Referral Bonus for every new user who joins using your code and plays a paid bid.
The bonus may vary depending on ongoing offers. Check the app for the latest details.`
      },
      {
        question: 'Where can I find my referral code?',
        answer: `Your referral code is available in the ‘Invite Friends’ section of the Nifty10 app.
Share it through WhatsApp, SMS, or social media to invite others.`
      }
    ]
  },
  {
    category: 'Discount Bonuses',
    items: [
      {
        question: 'What is a Discount Bonus on Nifty10?',
        answer: `A Discount Bonus is a reward that reduces the entry fee when you join a paid slot.
You can earn it through referrals, special offers, or as part of onboarding rewards.`
      },
      {
        question: 'How do I use my Discount Bonus?',
        answer: `When you join a bid that allows bonuses, the Discount Bonus will be automatically applied.
You pay the remaining amount with your wallet or other payment methods.`
      },
      {
        question: 'Can I withdraw my Discount Bonus?',
        answer: `No, Discount Bonus cannot be withdrawn. It can only be used to join bids on Nifty10.`
      }
    ]
  },
  {
    category: 'Special Offers & Events',
    items: [
      {
        question: 'What are Special Offers on Nifty10?',
        answer: `Special Offers are limited-time bonuses or contests launched during festive seasons, market events, or app promotions.
Stay tuned in the app and notifications for upcoming events!`
      },
      {
        question: 'How will I know if there’s a new offer?',
        answer: `You’ll receive in-app notifications and banners when there’s a new offer.
Make sure your notifications are turned on to stay updated.`
      }
    ]
  }
]


};

export default faqsByTopic;